const MODEL_NAME_SEPARATOR = /[,\u3001\uFF64]/

/**
 * Splits model names from metadata cells while accepting comma characters
 * commonly introduced by spreadsheet exports and copied text.
 */
export const parseModelNames = (value: string | null | undefined): string[] =>
    (value ?? '')
        .normalize('NFKC')
        .split(MODEL_NAME_SEPARATOR)
        .map((modelName) => modelName.trim())
        .filter(Boolean)
